import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { columns } from "./components/columns";
import { DataTable } from "./components/data-table";
import { useFilterState } from "./filter/hooks/filterState";
import { Load } from "components/load";
import PageError from "components/page-error";
import { ErrorBoundary } from "@/components/error-boundary";
import { usePropagationCampaignsData } from "./filter/hooks/usePropagationCampaignsData";

export function CampaignPropagationList() {
  const filters = useFilterState();

  const {
    campaigns: data,
    meta,
    isLoading,
    isFetching,
    error,
  } = usePropagationCampaignsData({
    page: filters.page,
    perPage: filters.limit,
    ...(filters.campaignType && { campaignType: filters.campaignType }),
    ...(filters.overallStatus && { overallStatus: filters.overallStatus }),
  });

  const pagination = {
    page: meta?.currentPage || 1,
    limit: meta?.perPage || 50,
    total: meta?.total || 0,
    totalPages: meta?.lastPage || 1,
  };

  if (isLoading && !data.length) return <Load />;
  if (error) {
    return <PageError status={500} message={"ERRO INTERNO NO SERVIDOR"} />;
  }

  return (
    <ErrorBoundary>
      <PageLayout>
        <PageTitle
          title="Auditoria de Propagação"
          description="Acompanhe o status de propagação das campanhas para as lojas"
        />
        <ContentContainer>
          <DataTable
            columns={columns}
            data={data}
            pagination={pagination}
            isLoading={isLoading || isFetching}
          />
        </ContentContainer>
      </PageLayout>
    </ErrorBoundary>
  );
}
